import { useEffect, useState } from "react";
import "../support-extra/css/CashPopup.css";
import "../css/SalesExportPopup.css";
import {
  userData,
  exportableFieldsSales,
  selectedOptic,
  focusElement,
} from "../js/utils";
import { post, download } from "../js/post";
import { ExportableField } from "./ExportableField";
import RadioButton from "./RadioButton";
import Dropdown from "./Dropdown";
import ButtonIconH from "./ButtonIconH";
import InputData from "./InputData";
import PopupMessage from "./PopupMessage";
import LoadingScreen from "./LoadingScreen";
import moment from "moment";
import "moment/locale/es";

export function SalesExportPopup({
  opticalList,
  agentList,
  campaign,
  startDate,
  endDate,
  show,
  onClose,
  createPopupQuestion,
  removePopupQuestion,
}) {
  const [selectedFields, setSelectedFields] = useState(
    exportableFieldsSales.filter((e) => e.default === true).map((e) => e.id),
  );
  const [data, setData] = useState({
    token: userData.token,
    idOpticaEmail: selectedOptic.id,
    opticas: opticalList,
    agentes: agentList,
    campana: campaign,
    fechaDesde: startDate,
    fechaHasta: endDate,
    tipoInforme: 0,
    datos0: selectedFields,
    datos1: {
      empresa: "",
      ejercicio: "",
      opcion: 0,
    },
    datos2: 0,
    tipoFichero: 0,
    email: "",
  });
  const [searchYear, setSearchYear] = useState(moment());
  const [errorEmail, setErrorEmail] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [sendingEmailMessage, setSendingEmailMessage] = useState("");
  const [sendingEmailMessageDef, setSendingEmailMessageDef] = useState("");

  const resetData = () => {
    setData({
      token: userData.token,
      idOpticaEmail: selectedOptic.id,
      opticas: opticalList,
      agentes: agentList,
      campana: campaign,
      fechaDesde: startDate,
      fechaHasta: endDate,
      tipoInforme: 0,
      datos0: selectedFields,
      datos1: {
        empresa: "",
        ejercicio: "",
        opcion: 0,
      },
      datos2: 0,
      tipoFichero: 0,
      email: "",
    });
    setErrorEmail(false);
    setSelectedFields(
      exportableFieldsSales.filter((e) => e.default === true).map((e) => e.id),
    );
    setSearchYear(moment());
  };

  const checkEmail = async () => {
    if (errorEmail || data.email === "") {
      createPopupQuestion(
        "Por favor, introduzca un email correcto.",
        () => {
          setErrorEmail(false);
          focusElement(30);
          removePopupQuestion();
          return;
        },
        null,
        "Entendido",
      );
    } else await exportFile(true);
  };

  const handleSelectAll = () => {
    if (data.tipoInforme === 0)
      setSelectedFields(exportableFieldsSales.map((e) => e.id));
  };

  const handleDeleteAll = () => {
    if (data.tipoInforme === 0) setSelectedFields([]);
  };

  const handleSelect = (id) => {
    if (data.tipoInforme === 0)
      setSelectedFields((prev) => [...new Set([...prev, id])]);
  };

  const handleDelete = (id) => {
    if (data.tipoInforme === 0)
      setSelectedFields((prev) => prev.filter((f) => f !== id));
  };

  async function exportFile(email) {
    const dataAux = {
      ...data,
      email: !email ? "" : data.email,
      idOpticaEmail: !email ? "" : data.idOpticaEmail,
    };
    if (!email) {
      setSendingEmailMessageDef(
        <LoadingScreen message="Generando archivo..."></LoadingScreen>,
      );
      setSendingEmail(true);
      const response = await download(
        "support-extra/dashboard/ExportacionVentas.php",
        dataAux,
      );
      if (response.error !== "") {
        setSendingEmailMessage(response.error);
      } else setSendingEmail(false);
    } else {
      setSendingEmailMessageDef(
        <LoadingScreen message="Enviando archivo..."></LoadingScreen>,
      );
      setSendingEmail(true);
      const response = await post(
        "support-extra/dashboard/ExportacionVentas.php",
        dataAux,
      );
      if (response.error !== "") {
        setSendingEmailMessage(response.error);
      } else {
        setSendingEmailMessage("El email se ha enviado correctamente.");
      }
    }
  }

  async function getCompanies() {
    const response = await post("support/Configuracion/ListarEmpresas.php", {
      token: userData.token,
    });

    if (response.length > 0) {
      setCompanyList(
        response.map((e) => ({
          id: e.idEmpresa,
          text: e.nombre_empresa,
        })),
      );
    }
  }

  useEffect(() => {
    getCompanies();
  }, []);

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      datos0: selectedFields,
    }));
  }, [selectedFields]);

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      datos1: {
        ...prev.datos1,
        ejercicio: moment(searchYear).year(),
      },
    }));
  }, [searchYear]);

  useEffect(() => {
    setData({
      token: userData.token,
      idOpticaEmail: selectedOptic.id,
      opticas: opticalList,
      agentes: agentList,
      campana: campaign,
      fechaDesde: startDate,
      fechaHasta: endDate,
      tipoInforme: 0,
      datos0: selectedFields,
      datos1: {
        empresa: "",
        ejercicio: "",
        opcion: 0,
      },
      datos2: 0,
      tipoFichero: 0,
      email: "",
    });
  }, [opticalList, agentList, campaign, startDate, endDate]);

  return (
    show && (
      <div className="sales-export-popup">
        <div className="popup-message-extra background-gray">
          {sendingEmail && (
            <PopupMessage
              text={
                sendingEmailMessage === ""
                  ? sendingEmailMessageDef
                  : sendingEmailMessage
              }
              textAccept={sendingEmailMessage === "" ? null : "Entendido"}
              onClickAccept={
                sendingEmailMessage === ""
                  ? null
                  : () => {
                      setSendingEmailMessage("");
                      setSendingEmailMessageDef("");
                      setSendingEmail(false);
                    }
              }
            ></PopupMessage>
          )}
          <div className="popup-header">
            <div className="popup-title">Exportación</div>
            <button
              className="popup-action-icon"
              onClick={() => {
                resetData();
                onClose();
              }}
            >
              <img
                src="images/close-white.svg"
                loading="lazy"
                alt="Close"
                className="popup-close"
              />
            </button>
          </div>
          <div className="popup-body container-panel" style={{ margin: 10 }}>
            <div className="dashboard-sec-row">
              <div
                style={{
                  width: 30,
                  display: "flex",
                  justifyContent: "center",
                  height: 50,
                  alignItems: "center",
                }}
              >
                <RadioButton
                  active={data.tipoInforme === 0}
                  onClick={() => {
                    resetData();
                    setData((prev) => ({ ...prev, tipoInforme: 0 }));
                  }}
                ></RadioButton>
              </div>
              <div
                className={`dashboard-section ${
                  data.tipoInforme === 0
                    ? "rdbtn-selectable-on"
                    : "rdbtn-selectable-off"
                }`}
              >
                <div className="dashboard-section-title">
                  <div className="opt-table-title opt-table-title-dash-stats">
                    Listado de ventas personalizado ({selectedFields.length}/
                    {exportableFieldsSales.length})
                  </div>
                  <>
                    <button
                      className="cell-label"
                      style={{ width: "170px" }}
                      onClick={handleSelectAll}
                      tabIndex={-1}
                    >
                      Seleccionar todo
                    </button>
                    <button
                      className="cell-label"
                      style={{ width: "170px" }}
                      onClick={handleDeleteAll}
                      tabIndex={-1}
                    >
                      Limpiar selección
                    </button>
                  </>
                </div>
                <div className="exportable-fields-container">
                  {exportableFieldsSales.map((e) => {
                    return (
                      <ExportableField
                        key={e.id}
                        data={e}
                        selected={selectedFields.includes(e.id)}
                        onSelect={handleSelect}
                        onDelete={handleDelete}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="dashboard-sec-row">
              <div
                style={{
                  width: 30,
                  display: "flex",
                  justifyContent: "center",
                  height: 50,
                  alignItems: "center",
                }}
              >
                <RadioButton
                  active={data.tipoInforme === 1}
                  onClick={() => {
                    resetData();
                    setData((prev) => ({ ...prev, tipoInforme: 1 }));
                  }}
                ></RadioButton>
              </div>
              <div
                className={`dashboard-section ${
                  data.tipoInforme === 1
                    ? "rdbtn-selectable-on"
                    : "rdbtn-selectable-off"
                }`}
              >
                <div className="opt-table-title opt-table-title-dash-stats">
                  Listado de ventas predeterminado
                </div>
                <div
                  className="opt-table-content grid-14"
                  id="sales-export-data1"
                >
                  <div className="cell">
                    <RadioButton
                      active={data.datos1.opcion === 0}
                      onClick={() => {
                        if (data.tipoInforme === 1) {
                          setData((prev) => ({
                            ...prev,
                            datos1: {
                              ...prev.datos1,
                              opcion: 0,
                            },
                          }));
                        }
                      }}
                    ></RadioButton>
                  </div>
                  <div className="cell cell-start-content">Agrupado diario</div>
                  <div className="cell"></div>
                  <div className="cell">
                    <RadioButton
                      active={data.datos1.opcion === 1}
                      onClick={() => {
                        if (data.tipoInforme === 1) {
                          setData((prev) => ({
                            ...prev,
                            datos1: {
                              ...prev.datos1,
                              opcion: 1,
                            },
                          }));
                        }
                      }}
                    ></RadioButton>
                  </div>
                  <div className="cell cell-start-content">
                    Agrupado mensual
                  </div>
                  <div className="cell"></div>
                  <div className="cell">
                    <RadioButton
                      active={data.datos1.opcion === 2}
                      onClick={() => {
                        if (data.tipoInforme === 1) {
                          setData((prev) => ({
                            ...prev,
                            datos1: {
                              ...prev.datos1,
                              opcion: 2,
                            },
                          }));
                        }
                      }}
                    ></RadioButton>
                  </div>
                  <div className="cell cell-start-content">
                    Agrupado trimestral
                  </div>
                  <div className="cell"></div>
                  <div className="cell">
                    <RadioButton
                      active={data.datos1.opcion === 6}
                      onClick={() => {
                        if (data.tipoInforme === 1) {
                          setData((prev) => ({
                            ...prev,
                            datos1: {
                              ...prev.datos1,
                              opcion: 6,
                            },
                          }));
                        }
                      }}
                    ></RadioButton>
                  </div>
                  <div className="cell cell-start-content">347</div>
                  <div className="cell"></div>
                  <div className="cell cell-start-content">Empresa</div>
                  <div className="cell">
                    <Dropdown
                      size={0}
                      disabled={data.datos1.opcion !== 6}
                      optionList={companyList}
                      op={data.datos1.empresa}
                      onChange={(e) => {
                        setData((prev) => ({
                          ...prev,
                          datos1: {
                            ...prev.datos1,
                            empresa: e.text,
                          },
                        }));
                      }}
                    ></Dropdown>
                  </div>
                  <div className="cell">
                    <RadioButton
                      active={data.datos1.opcion === 3}
                      onClick={() => {
                        if (data.tipoInforme === 1) {
                          setData((prev) => ({
                            ...prev,
                            datos1: {
                              ...prev.datos1,
                              opcion: 3,
                            },
                          }));
                        }
                      }}
                    ></RadioButton>
                  </div>
                  <div className="cell cell-start-content">Detallado</div>
                  <div className="cell"></div>
                  <div className="cell">
                    <RadioButton
                      active={data.datos1.opcion === 4}
                      onClick={() => {
                        if (data.tipoInforme === 1) {
                          setData((prev) => ({
                            ...prev,
                            datos1: {
                              ...prev.datos1,
                              opcion: 4,
                            },
                          }));
                        }
                      }}
                    ></RadioButton>
                  </div>
                  <div className="cell cell-start-content">
                    Ventas sin abonar
                  </div>
                  <div className="cell"></div>
                  <div className="cell">
                    <RadioButton
                      active={data.datos1.opcion === 5}
                      onClick={() => {
                        if (data.tipoInforme === 1) {
                          setData((prev) => ({
                            ...prev,
                            datos1: {
                              ...prev.datos1,
                              opcion: 5,
                            },
                          }));
                        }
                      }}
                    ></RadioButton>
                  </div>
                  <div className="cell cell-start-content">Comisiones</div>
                  <div className="cell combined-cells-4"></div>
                  <div className="cell cell-start-content">Ejercicio</div>
                  <div className="cell">
                    <div className="data-field">
                      <button
                        className="incdec-btn"
                        onClick={() => {
                          if (data.tipoInforme === 1)
                            setSearchYear((prev) =>
                              moment(prev).subtract(1, "year"),
                            );
                        }}
                      >
                        {"<"}
                      </button>
                      <span style={{ width: "60px", textAlign: "center" }}>
                        {moment(searchYear).year()}
                      </span>
                      <button
                        className="incdec-btn"
                        onClick={() => {
                          if (data.tipoInforme === 1)
                            setSearchYear((prev) =>
                              moment(prev).add(1, "year"),
                            );
                        }}
                      >
                        {">"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="dashboard-sec-row">
              <div
                style={{
                  width: 30,
                  display: "flex",
                  justifyContent: "center",
                  height: 50,
                  alignItems: "center",
                }}
              >
                <RadioButton
                  active={data.tipoInforme === 2}
                  onClick={() => {
                    resetData();
                    setData((prev) => ({ ...prev, tipoInforme: 2 }));
                  }}
                ></RadioButton>
              </div>
              <div
                className={`dashboard-section ${
                  data.tipoInforme === 2
                    ? "rdbtn-selectable-on"
                    : "rdbtn-selectable-off"
                }`}
              >
                <div className="opt-table-title opt-table-title-dash-stats">
                  Cierres de caja de formato predeterminado
                </div>
                <div
                  className="opt-table-content grid-14"
                  id="sales-export-data1"
                >
                  <div className="cell">
                    <RadioButton
                      active={data.datos2 === 0}
                      onClick={() => {
                        if (data.tipoInforme === 2) {
                          setData((prev) => ({
                            ...prev,
                            datos2: 0,
                          }));
                        }
                      }}
                    ></RadioButton>
                  </div>
                  <div className="cell cell-start-content">Caja estándar</div>
                  <div className="cell"></div>
                  <div className="cell">
                    <RadioButton
                      active={data.datos2 === 1}
                      onClick={() => {
                        if (data.tipoInforme === 2) {
                          setData((prev) => ({
                            ...prev,
                            datos2: 1,
                          }));
                        }
                      }}
                    ></RadioButton>
                  </div>
                  <div className="cell cell-start-content">Caja detallada</div>
                  <div className="cell combiend-cells-9"></div>
                </div>
              </div>
            </div>
            <div className="dashboard-section">
              <div className="opt-table-title opt-table-title-dash-stats">
                Tipo de archivo
              </div>
              <div className="opt-table-content grid-10" id="dashboard-export">
                <div className="cell">
                  <RadioButton
                    active={data.tipoFichero === 0}
                    onClick={() => {
                      setData((prev) => ({
                        ...prev,
                        tipoFichero: 0,
                      }));
                    }}
                  ></RadioButton>
                </div>
                <div className="cell">Archivo PDF</div>
                <div className="cell"></div>
                <div className="cell">
                  <RadioButton
                    active={data.tipoFichero === 1}
                    onClick={() => {
                      setData((prev) => ({
                        ...prev,
                        tipoFichero: 1,
                      }));
                    }}
                  ></RadioButton>
                </div>
                <div className="cell">Archivo EXCEL</div>
                <div className="cell"></div>
                <div className="cell">
                  <RadioButton
                    active={data.tipoFichero === 2}
                    onClick={() => {
                      setData((prev) => ({
                        ...prev,
                        tipoFichero: 2,
                      }));
                    }}
                  ></RadioButton>
                </div>
                <div className="cell">Archivo CSV</div>
                <div className="cell"></div>
                <div className="cell cell-start-content">
                  <ButtonIconH
                    text="Exportar"
                    small={true}
                    onClick={async () => await exportFile(false)}
                  ></ButtonIconH>
                </div>
                <div className="cell combined-cells-2">Enviar por email</div>
                <div className="cell combined-cells-6 cell-start-content">
                  <InputData
                    type="type-email"
                    size={0}
                    input={data.email}
                    onChange={(e) => {
                      setData((prev) => ({
                        ...prev,
                        email: e,
                      }));
                    }}
                    onMalformed={() => setErrorEmail(true)}
                    error={errorEmail}
                  ></InputData>
                </div>
                <div className="cell"></div>
                <div className="cell cell-start-content">
                  <ButtonIconH
                    text="Enviar"
                    small={true}
                    onClick={checkEmail}
                  ></ButtonIconH>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
}
